import React from "react";
import Hero from "../components/home/Hero";
import Setup from "../components/home/Setup";
import PrebuiltForms from "../components/home/PrebuiltForms";
import SupportedInputs from "../components/home/SupportedInputs";

const Home = () => {
    return (
        <>
            <Hero/>
            <Setup/>
            <PrebuiltForms/>
            <SupportedInputs/>
            {/*<ContactUs/>*/}
        </>
    );
};

export default Home;